import { Loader } from "@/components/ui/loader";

export function ErrorMessage(props: { message: string | unknown }) {
  const message =
    typeof props.message === "string"
      ? props.message
      : "Si è verificato un errore";
  return (
    <>
      <div className="flex gap-x-4 items-center justify-between">
        <h2 className="font-semibold text-sm">
          Oops! Si è verificato un errore
        </h2>
        <Loader className="h-6 w-6 ruby text-scale-9" state="error" />
      </div>
      <p className="mt-4 text-neutral-10">{message}</p>
    </>
  );
}
